import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UploadSpeedTestMutation,
  UploadSpeedTestMutationVariables,
} from "./UploadSpeedTest.generated";

const UPLOAD_SPEED_TEST: TypedDocumentNode<
  UploadSpeedTestMutation,
  UploadSpeedTestMutationVariables
> = gql`
  mutation uploadSpeedTest($file: String!) {
    uploadSpeedTest(file: $file) {
      result {
        success
        fileSize
      }
    }
  }
`;

export default UPLOAD_SPEED_TEST;
